// style
// @ts-ignore
import './style/home.css'
// link
import { useNavigate, useParams } from "react-router-dom";
// hook
import { useEffect, useState } from "react";
// split number
import { splitNumber } from "../../../features/splitNumber/splitNumber";
// make query
import { useMutation } from "@tanstack/react-query";
// component
import Loading from "../../../components/loading/loading";
// cookie
// @ts-ignore
import Cookies from 'js-cookie';
// layouts
import { sendPaymentInfo2 } from '../../../services/charge/charge2';
// sep share token flow
import { fetchSepShareTokenFlow } from '../../../services/auth/sepToken';

const HomePaymentGoyaK = () => {
    const { id }: any = useParams();
    const [user, setUser] = useState<any>()
    const [status, setStatus] = useState<boolean>(false);
    const [sepToken, setSepToken] = useState<string | null>(null);
    const [sepTokenLoading, setSepTokenLoading] = useState<boolean>(false);
    const [sepTokenError, setSepTokenError] = useState<string | null>(null);
    const mutation_2 = useMutation({
        mutationFn: sendPaymentInfo2,
        onSuccess: data => {
            if (data) {
                setUser(data)
                Cookies.set('irt', 'false');
                // @ts-ignore
                if (data?.isWallet === false) {
                    setStatus(true)
                } else {
                    setStatus(false)
                }
                Cookies.set('userData', JSON.stringify(data), { expires: 7 });
                const resNum = data.resNum;
                if (!resNum) return;
                let isCancelled = false;
                setSepTokenLoading(true);
                setSepTokenError(null);
                fetchSepShareTokenFlow(resNum)
                    .then(({ sepData }) => {
                        if (isCancelled) return;
                        setSepToken(sepData?.data ?? null);
                    })
                    .catch(err => {
                        if (isCancelled) return;
                        setSepTokenError(err?.message || 'خطا در دریافت توکن پرداخت');
                    })
                    .finally(() => {
                        if (!isCancelled) setSepTokenLoading(false);
                    });

                return () => {
                    isCancelled = true;
                };
            } else {
            }
        },
        onError: (error) => {
            // navigate('/error/message')
        },
    });

    useEffect(() => {
        document.getElementById('site-main')?.classList.remove('main-content')
        document.getElementById('site-main')?.classList.add('bg-payment-new')
        document.getElementById('site-main')?.classList.add('bg-payment-new-home')
        document.getElementById('site-main')?.classList.add('bg-white')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        mutation_2.mutate(id);
    }, []);

    return (
        <>
            <article className={'payment overflow-x-hidden'}>
                <div className="row justify-content-center h-100">
                    <header className={'container text-center'}>
                        <div className="top-bar" style={{ paddingBottom: '15px' }}>
                            <div className="d-flex justify-content-center">
                                {/* @ts-ignore */}
                                <img alt="logo" src={require('./../../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp')} className="img-fluid" />
                            </div>
                            <p className="text-white text-center mb-5 fw-bold">
                                سامانه ملی امن, سریع و آسان تراکنش ایران
                            </p>
                        </div>
                    </header>
                    <div className="col-md-6 col-lg-4">
                        {mutation_2.isPending ? (
                            <Loading />
                        ) : (
                            <>
                                <section style={{ marginTop: '-40px' }} className={'profile container'}>
                                    <div className={'profile-items d-flex justify-content-center text-center'}>
                                        {status ?
                                            (
                                                <>
                                                    {user?.image ? (
                                                        <>
                                                            <img alt='profile' className={'profile-img-valid'} src={user.image} />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <img
                                                                alt='profile'
                                                                className='profile-img-valid'
                                                                // @ts-ignore
                                                                src={require('./../../../assets/media/images/payment/Profile_Vr_01 1.png')} />
                                                        </>
                                                    )}
                                                </>
                                            ) :
                                            (
                                                <>
                                                    <p className={'text-center font-medium mt-2 fw-bold'}>
                                                        شارژ حساب کاربری ایران تراکنش
                                                    </p>
                                                </>
                                            )
                                        }
                                    </div>
                                    {status ?
                                        (
                                            <>
                                                <p className={'fw-bold text-center mt-3 mb-1'}>
                                                    <span>
                                                        {user?.irtName}
                                                    </span>
                                                </p>
                                            </>
                                        ) :
                                        <></>
                                    }
                                    {user?.urlName !== 'Shufti' ?
                                        (
                                            <>
                                                <p className={'text-muted text-center mb-2'}>
                                                    {status ? user?.merchantCode : `${user?.mobile}`}
                                                </p>
                                            </>
                                        )
                                        : null}
                                </section>
                                {status ? (
                                    <>
                                        <section id={'endPoint'} className={'container text-center mt-2'}>
                                            <span className="badge bg-success-site font-medium mt-2 py-2 fw-bold" style={{ fontSize: '18px' }}>
                                                مبلغ قابل پرداخت
                                            </span>
                                            <p className={'price dark-green card-text mt-3 h4 fw-bold'}>
                                                <span className={'price-amount ms-1'}>
                                                    {splitNumber((user?.price + user?.currentBalance) / 10)}
                                                </span>
                                                تومان
                                            </p>
                                        </section>
                                    </>
                                ) : null}
                                {!status ?
                                    (
                                        <>
                                            <section id={'endPoint'} className={'container text-center mt-2'}>
                                                <span className="badge bg-success-site font-medium mt-2 py-2 fw-bold" style={{ fontSize: '18px' }}>
                                                    مبلغ قابل پرداخت
                                                </span>
                                                <p className={'price dark-green card-text mt-3 h4 fw-bold'}>
                                                    <span className={'price-amount ms-1'}>
                                                        {splitNumber(user?.price / 10)}
                                                    </span>
                                                    تومان
                                                </p>
                                            </section>
                                        </>
                                    ) : null}
                                <div className='container-fluid'>
                                    <section className={'alert d-flex bg-success-site justify-content-between py-3 my-2 mt-3'}>
                                        <p className={'font-small fw-bold text-white fw-bold mb-0'}>
                                            {status ? 'برداشت از کارت بانکی شما' : 'موجودی ایران تراکنش شما قبل از پرداخت'}
                                        </p>
                                        <p className={'price font-small fw-bold text-white mb-0'}>
                                            <span className={'price-amount ms-1'}>
                                                {splitNumber(status ? user?.price / 10 : user?.currentBalance / 10)}
                                            </span>
                                            تومان
                                        </p>
                                    </section>
                                </div>
                                <hr />
                                <section className={'action container w-100 my-1 mt-2'}>
                                    <div className={'d-flex w-100 justify-content-center w-100'}>
                                        {sepTokenLoading ? (
                                            '...'
                                        ) : sepTokenError ? (
                                            <p className='text-danger text-center w-100'>{sepTokenError}</p>
                                        ) : (
                                            <form className='w-100 text-center' method={'post'} action={'https://sep.shaparak.ir/OnlinePG/OnlinePG'}>
                                                <input type={'hidden'} name={'Token'} value={sepToken ?? user?.externalCode} />
                                                <input type={'text'} name={'GetMethod'} value={''} className={'d-none'} />
                                                <button
                                                    className={'btn btn-site w-100 px-5 mb-3 text-white'}>
                                                    <p className={'card-text'}>
                                                        تایید و پرداخت
                                                    </p>
                                                </button>
                                                <span style={{ borderBottom: '1px solid #FFB72B' }} className={'font-small mt-3 rounded-3 mb-0 text-center'}>
                                                    بدون نیاز به نصب اپلیکیشن
                                                </span>
                                            </form>
                                        )}
                                    </div>
                                </section>
                                {user?.urlName === 'Hashin' || user?.urlName === 'DigiDollar' || user?.urlName === 'Combat' || user?.urlName === 'Holoo' || user?.urlName === 'Corevia' || user?.urlName === 'Sepidar' || user?.urlName === 'Shufti' ? (
                                    <div className='d-flex justify-content-center'>
                                        {/* @ts-ignore */}
                                        {user?.urlName === 'Hashin' ?
                                            (
                                                <img src={require('./../../../assets/media/logo/hashin.png')} alt="" className='mt-3' />
                                            )
                                            : null}
                                        {user?.urlName === 'DigiDollar' ?
                                            (
                                                <img src={require('./../../../assets/media/logo/digi.png')} alt="" style={{ width: '70px', height: '70px' }} className='mt-3' />
                                            )
                                            : null}
                                        {user?.urlName === 'Combat' ?
                                            (
                                                <img src={require('./../../../assets/media/logo/combat.png')} alt="" style={{ width: '100px', height: '80px' }} className='mt-3' />
                                            )
                                            : null}
                                        {user?.urlName === 'Holoo' ?
                                            (
                                                <img src={require('./../../../assets/media/logo/holloo.png')} alt="" style={{ width: '100px', height: '80px' }} className='mt-3' />
                                            )
                                            : null}
                                        {user?.urlName === 'Corevia' || user?.urlName === 'Sepidar' ?
                                            (
                                                <img src={require('./../../../assets/media/logo/corevia-lockup-square.png')} alt="" style={{ width: '100px', height: '80px' }} className='mt-3' />
                                            )
                                            : null}
                                        {user?.urlName === 'Shufti' ?
                                            (
                                                <img src={require('./../../../assets/media/logo/sh.png')} alt="" style={{ width: '100px', height: '80px' }} className='mt-3' />
                                            )
                                            : null}
                                    </div>
                                ) : null}
                            </>
                        )}
                    </div>
                </div>
            </article>
        </>
    )
}

export default HomePaymentGoyaK;
